


















































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import states from '@assets/states.json'
import dma from '@assets/dma.json'
import ImpersonateMenu from '@/components/ImpersonateMenu'

settings =
  name: "Onboarding"
  resources:
    onboardingWizard:
      resourceName: "onboarding_wizard"
      slug: "onboarding_wizards/:member.token/edit"
  vue:
    components: {
      ImpersonateMenu,
    }

    data: ->
      state_options: states
      dma_options: dma

      form:
        wait_listed: true
        brand_rep:
          first_name: null
          last_name: null
          market_interest:
            state_list: []
            dma_list: []
            store_list: []
            other_retail_stores: ''
        sponsor:
          id: null
          organization_name: null
        sub_organization:
          id: null
          organization_name: null

    computed:
      member: -> @$store.member
      otherStoreSelected: -> @form.brand_rep.market_interest.store_list.includes('other')

    methods:
      saveWizard: ->
        @prime.onboardingWizard[field] = data for field, data of @form
        @saveItem 'onboardingWizard', @prime.onboardingWizard
      onSave: (item)->
        @setCurrentMember(item)
        @navigateToDashboard()

    updated: ->
      return unless @prime.onboardingWizard?
      @form.brand_rep.first_name ||= @prime.onboardingWizard.brand_rep.first_name
      @form.brand_rep.last_name ||= @prime.onboardingWizard.brand_rep.last_name

export default VueOptions.vue settings
